import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/landing/HeroSection";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { DifferentiatorSection } from "@/components/landing/DifferentiatorSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Acasă"
        description="Prima platformă SEO + GEO din România. Optimizează site-ul pentru Google și motoare AI precum ChatGPT, Gemini și AI Overview."
        canonical="https://optiro.ai"
      />
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <ProblemSection />
        <DifferentiatorSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
